/**** Common Helpers ****/

import forms from "./components/Form/forms.js";
import { defaultScrollInit } from "./common/scrollIntoView.js";
import inPageNavigation from "./common/inPageNavigation.js";
import { initMakeClickable } from "./common/makeClickable.js";

// This is required to make Storybook run JS when patterns are choosen
document.addEventListener("DOMContentLoaded", () => {
  // run this first since it is blanket query search that could affect other apps.
  const pageNav = inPageNavigation(document.querySelectorAll('a[href*="#"]'));
  pageNav.handleHashUrl();

  forms();
  defaultScrollInit();
  initMakeClickable();
});
